// gatsby-browser.js
import React from 'react';

import AnimatedLayout from './src/components/AnimatedLayout';
import './global.css';

const isAnimatedPage = (pathname) => {
  const animatedPages = ['/', '/research/', '/design/', '/about/'];
  return animatedPages.includes(pathname);
};

export const wrapPageElement = ({ element, props }) => {
  const { location } = props;
  if (isAnimatedPage(location.pathname)) {
    return (
        <AnimatedLayout location={location}>{element}</AnimatedLayout>
    );
  }
  return element;
};


